var floating_banner = (function( $ ) {

	var _init = function() {
		$( '.close-icon' ).on( 'click', function() {
			$( '.floating-banner-wrapper' ).hide();
			set_cookie( 'hide_banner', 'true' );
		} );
	};

	var should_hide_banner = function() {
		return $.cookie( 'hide_banner' ) === 'true';
	};

	var set_cookie = function( name, value ) {
		var currentDate = new Date();
		currentDate.setMinutes( currentDate.getMinutes() + (48 * 60) );
		$.cookie( name, value, {
			expires: currentDate,
			path:    '/'
		} );
	};

	$( document ).ready( _init );

	return {};

})( jQuery );

module.exports = floating_banner;